module.exports = __webpack_public_path__ + "static/img/250xwashable.ebaa43a0.svg";